export const styles = (theme) => ({
  formControlLabel: {
    fontSize: theme.typography.pxToRem(13),
  },
});

export default styles;
